// extracted by mini-css-extract-plugin
export default {"table":"Packages_table__8Qz8t","row":"Packages_row__uF2OR"};